import { IFavoriteRecommendationOffer } from '../repositories/favorites/entities/recommendations/FavoriteRecommendationOffer';
import type { TOfferAnalyticsData, TRecommendation } from '../types/recommendation';

export function prepareRecommendations(rawRecommendations: IFavoriteRecommendationOffer[]): TRecommendation[] {
  return rawRecommendations.map(
    (
      {
        analyticsData,
        dealType,
        discount,
        entityId,
        entityType,
        imageUrl,
        info,
        isFavorite,
        offerType,
        text,
        title,
        underground,
        url,
      },
      index,
    ) => ({
      description: text ?? undefined,
      href: url,
      imageUrl: imageUrl || '',
      title: title ?? undefined,
      info: info ?? undefined,
      analyticsData: {
        offerId: entityId,
        type: 'offer',
        ...analyticsData,
        products: [
          {
            id: entityId,
            offerType: 'offer',
            position: index + 1,
          },
        ],
      } as TOfferAnalyticsData,
      offerId: entityId,
      underground: underground ?? undefined,
      isFavorite: isFavorite || false,
      dealType,
      offerType,
      entityType,
      discount: discount ?? undefined,
    }),
  );
}
